const TENS_THRESHOLD = 100;

export function roundedAvailable(available: number): number {
  if (available < 10) {
    return available;
  }

  const step = available < TENS_THRESHOLD ? 10 : 100;

  return Math.floor(available / step) * step;
}
